<ng-container *ngIf="data.showDuplicateDialog">
  <form class="example-form">
    <h3 mat-dialog-title>Test Duplication</h3>
    <div class="border-bottom align-self-center"></div>
    <div mat-dialog-content>
      <mat-form-field class="example-full-width">
        <mat-label>Duplicate name</mat-label>
        <input matInput [(ngModel)]="duplicateName" name="newName"  #duplicateInput="ngModel" required>
      </mat-form-field>
      <div class="validation mt-n3"
           *ngIf="duplicateName.length > 100 || duplicateInput.invalid">
        Maximum character count is 100․
      </div>
    </div>
    <div mat-dialog-actions class="float-end m-1 mb-3">
      <button class="btn border-sm rounded-5 btn-color-purple mobile-button" (click)="onNoClick()">Cancel</button>
      <button class="btn btn-primary rounded-5 mx-2 mobile-button" [mat-dialog-close]="duplicateName" (click)="duplicate()" [disabled]="duplicateName.length > 100 || duplicateInput.invalid">Duplicate</button>
    </div>
  </form>
</ng-container>
<ng-container *ngIf="data.showDeleteDialog">
  <h2 mat-dialog-title>Deleting test and results</h2>
  <div mat-dialog-content>Are you sure you want to permanently delete selected test and collected results
    (respondents will be unable to access them as well)?
  </div>
  <div mat-dialog-actions class="float-end">
    <button class="btn border-sm rounded-5 btn-color-purple mobile-button" (click)="onNoClick()">Cancel</button>
    <button class="btn btn-primary rounded-5 mx-2 mobile-button" [mat-dialog-close]="true" (click)="deleteQuiz()">Delete</button>
  </div>
</ng-container>
